import { Grid, Pagination } from '@mui/material';
import React, { useState } from 'react';
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';

import { IPDFViewer } from './types';

const PDF: React.FC<IPDFViewer> = ({
    pdfBase64,
    scale = 0.8
}) => {
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = (pdf: any): void => {
        setNumPages(pdf.numPages);
        setPageNumber(1);
    };


  return (
        <>
            <Grid>
                <Document
                    file={`data:application/pdf;base64, ${pdfBase64}`}
                    // @ts-ignore
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={console.error}
                >
                    <Page
                        pageNumber={pageNumber}
                        scale={scale}
                        renderTextLayer
                    />
                </Document>
            </Grid>
            <Grid container xs={12} sx={{height: '60px', paddingTop: '10px', position: 'sticky', bottom: 0, background: '#fff'}}>
                {numPages > 1 && (
                    <Grid xs={12} item container justifyContent="center">
                        <Pagination
                            count={numPages}
                            onChange={(e, value): void => { e && setPageNumber(value) }}
                            page={pageNumber}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};
export default PDF;